// Радиус действия всех трёх способностей гоблинов (гекс-дистанция от отряда)
export const GOBLINS_ABILITY_RADIUS = 3;

// Минимальная численность отряда, необходимая для применения любой из способностей
export const GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY = 5;

// Порог успеха броска д6 для установки ловушки и повреждения строения
export const GOBLINS_ABILITY_SUCCESS_THRESHOLD = 3;

// Стоимость попытки установки ловушки в монетах - списывается независимо от исхода
export const GOBLINS_TRAP_SETUP_COST = 1;

// Награда в монетах за снятие своей ранее установленной ловушки (без броска кубика)
export const GOBLINS_TRAP_REMOVAL_REWARD = 1;

// Диапазон урона от одной сработавшей ловушки
export const GOBLINS_TRAP_MIN_DAMAGE = 1;
export const GOBLINS_TRAP_MAX_DAMAGE = 3;

// Штраф, вычитаемый из броска д6 при повреждении крепости гоблином (roll - штраф, не ниже 0)
export const GOBLINS_FORTRESS_DAMAGE_PENALTY = 2;

// Режимы способности, выбираемые в GoblinsAbilitiesToolbar (чисто клиентское
// UI-состояние, state.private.goblinsAbilityMode)
export const GOBLINS_ABILITY_MODES = {
  SET_TRAP: 'SET_TRAP',
  REMOVE_TRAP: 'REMOVE_TRAP',
  DAMAGE_BUILDING: 'DAMAGE_BUILDING',
};

// Сколько висит карточка «твой отряд попал в ловушку» (GoblinsTrapKillNotice)
// у игрока, чей отряд подорвался: раньше она ждала клика сколь угодно долго.
// Индикаторы срабатывания на поле этим таймером НЕ гасятся — они живут до
// конца этапа перемещения/маневра (сброс в goblinsTrapKillNoticeReducer по
// COMPLETE_PHASE/SET_WAR_PHASE_STAGE), чтобы игрок успел разглядеть, где и по
// кому сработали ловушки, даже если он уже кликнул по полю
export const GOBLINS_TRAP_KILL_NOTICE_AUTO_HIDE_MS = 5000;

// Цвет фракции - совпадает с --goblins-color в App.css. Дублируется в JS по
// тому же образцу, что и SUCCUBES_SEDUCTION_RESULT_COLOR: нужен для инлайн-
// стилизации замаскированных иконок (backgroundColor), которые CSS-классом
// (text-goblins, только color) не покрыть
export const GOBLINS_ABILITY_RESULT_COLOR = '#c2c141';
